import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "../../utils/apis";

export const addCollection = createAsyncThunk(
  "Collection/addCollection",
  async (data, { getState }) => {
    try {
      const {
        auth: {
          user: { token },
        },
      } = getState();
      const res = await API.postDataApi("Collection/Create", data, token);
      return res.data;
    } catch (error) {
      console.err(error);
      throw error;
    }
  }
);

export const addCollectionQuantity = createAsyncThunk(
  "Collection/addCollectionQuantity",
  async (data, { getState }) => {
    try {
      const {
        auth: {
          user: { token },
        },
      } = getState();
      const res = await API.postDataApi(
        "Collection/UpdateProduct",
        data,
        token
      );
      return res.data;
    } catch (error) {
      console.err(error);
      throw error;
    }
  }
);

export const updateCollection = createAsyncThunk(
  "Collection/updateCollection",
  async (data, { getState }) => {
    try {
      const {
        auth: {
          user: { token },
        },
      } = getState();
      const res = await API.postDataApi("Collection/Update", data, token);
      return res.data;
    } catch (error) {
      console.err(error);
      throw error;
    }
  }
);

export const getMyCollection = createAsyncThunk(
  "Collection/getMyCollection", // TODO: replace with myActiveDonations
  async (data, { getState }) => {
    try {
      const {
        auth: {
          user: { token, userId },
        },
      } = getState();

      const res = await API.getApi(`Collection/GetCollection`, data, token);
      return res.data.obj;
    } catch (error) {
      throw error;
    }
  }
);

export const getDonorDetailById = createAsyncThunk(
  "Collection/getDonorDetailById",
  async (data, { getState }) => {
    try {
      const {
        auth: {
          user: { token },
        },
      } = getState();
      const rsp = await API.getDataApi(
        `Registration/GetEntityDetailsById/${data.entityId}`,
        token
      );
      return rsp.data;
    } catch (error) {
      throw error;
    }
  }
);
export const GetEntityPreferenceEmail = createAsyncThunk(
  "Registration/GetEntityPreferenceEmail",
  async (data, { getState }) => {
    try {
      const {
        auth: {
          user: { token },
        },
      } = getState();
      const rsp = await API.getDataApi(
        `Registration/GetEntityPreferenceEmail/${data.entityId}`,
        token
      );
      return rsp.data;
    } catch (error) {
      throw error;
    }
  }
);

export const getMyHistoryCollection = createAsyncThunk(
  "Collection/getMyHistoryCollection", // TODO: replace with myActiveDonations
  async (data, { getState }) => {
    try {
      const {
        auth: {
          user: { token, userId },
        },
      } = getState();

      const res = await API.getApi(`Collection/GetCollection`, data, token);
      return res.data.obj;
    } catch (error) {
      throw error;
    }
  }
);

export const getMyDonationCollection = createAsyncThunk(
  "Collection/getMyDonationCollection", // TODO: replace with myActiveDonations
  async (data, { getState }) => {
    try {
      const {
        auth: {
          user: { token, userId },
        },
      } = getState();

      const res = await API.getApi(`Collection/GetCollection`, data, token);
      return res.data.obj;
    } catch (error) {
      throw error;
    }
  }
);

export const getCollectionIdByToken = createAsyncThunk(
  "Collection/getCollectionIdByToken",
  async (token, { getState }) => {
    const {
      auth: { user },
    } = getState();

    const res = await API.getDataApi(
      `Collection/GetCollectionIdByToken?token=${token}`,
      user.token
    );

    return res.data.collectionId; // retorna apenas o ID
  }
);

export const UpdatePedidoAlteracao = createAsyncThunk(
  "Collection/UpdatePedidoAlteracao",
  async (data, { getState }) => {
    try {
      const {
        auth: {
          user: { token },
        },
      } = getState();
      const res = await API.postDataApi(
        `Collection/UpdatePedidoAlteracao?id=${data}`,
        {},
        token
      );
      return res.data;
    } catch (error) {
      throw error;
    }
  }
);


export const UpdateDateCollection = createAsyncThunk(
  "Collection/UpdateDateCollection",
  async (data, { getState }) => {
    try {
      const {
        auth: {
          user: { token },
        },
      } = getState();
      const res = await API.postDataApi(
        `Collection/UpdateDateCollection?dateOfCollection=${data.dateOfCollection}&id=${data.id}`,
        {},
        token
      );

      return res.data;
    } catch (error) {
      console.err(error);
      throw error;
    }
  }
);

const initialState = {
  loading: false,
  collectionId: "",
  collectionDonationId: "",
  myCollections: {},
  myDonationCollections: {},
  donorDetail: {},
  historyCollection: {},
  status: "idle",
  collectionById: {},
};

export const collectionSlice = createSlice({
  name: "Collection",
  initialState,
  reducers: {
    resetCollection: (state) => {
      state = initialState;
    },
    setCollectionId: (state, action) => {
      state.collectionId = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(UpdateDateCollection.pending, (state, action) => {
        state.loading = true;
        state.status = "in-progress";
      })
      .addCase(UpdateDateCollection.fulfilled, (state, action) => {
        state.loading = false;
        state.status = "idle";
      })
      .addCase(UpdateDateCollection.rejected, (state, action) => {
        state.loading = false;
        state.status = "idle";
      })
      .addCase(UpdatePedidoAlteracao.pending, (state, action) => {
        state.loading = true;
        state.status = "in-progress";
      })
      .addCase(UpdatePedidoAlteracao.fulfilled, (state, action) => {
        state.loading = false;
        state.status = "idle";
      })
      .addCase(UpdatePedidoAlteracao.rejected, (state, action) => {
        state.loading = false;
        state.status = "idle";
      })
      .addCase(addCollection.pending, (state, action) => {
        state.status = "in-progress";
      })
      .addCase(addCollection.fulfilled, (state, action) => {
        state.status = "idle";
        state.collectionId = action.payload.collection.id;
        state.collectionDonationId = action.payload.collection.donationId;
      })
      .addCase(addCollection.rejected, (state, action) => {
        state.status = "idle";
      })
      .addCase(addCollectionQuantity.pending, (state, action) => {
        state.status = "in-progress";
      })
      .addCase(addCollectionQuantity.fulfilled, (state, action) => {
        state.status = "idle";
        state.collectionId = action.payload.collectionProduct.collectionId;
      })
      .addCase(addCollectionQuantity.rejected, (state, action) => {
        state.status = "idle";
      })
      .addCase(updateCollection.pending, (state, action) => {
        state.status = "in-progress";
      })
      .addCase(updateCollection.fulfilled, (state, action) => {
        state.status = "idle";
        state.collectionId = "";
        state.collectionDonationId = "";
      })
      .addCase(updateCollection.rejected, (state, action) => {
        state.status = "idle";
      })
      .addCase(getMyCollection.pending, (state, action) => {
        state.status = "in-progress";
      })
      .addCase(getMyCollection.fulfilled, (state, action) => {
        state.status = "idle";
        const collections = action.payload;
        state.myCollections = collections;
      })
      .addCase(getMyCollection.rejected, (state, action) => {
        state.status = "idle";
      })
      .addCase(getMyHistoryCollection.pending, (state, action) => {
        state.status = "in-progress";
        state.loading = true;
      })
      .addCase(getMyHistoryCollection.fulfilled, (state, action) => {
        state.status = "idle";
        state.loading = false;
        const collections = action.payload;
        state.historyCollection = collections;
      })
      .addCase(getMyHistoryCollection.rejected, (state, action) => {
        state.status = "idle";
        state.loading = false;
      })
      .addCase(getMyDonationCollection.pending, (state, action) => {
        state.status = "in-progress";
        state.loading = true;
      })
      .addCase(getMyDonationCollection.fulfilled, (state, action) => {
        state.loading = false;
        state.status = "idle";
        const collections = action.payload;
        state.myDonationCollections = collections;
      })
      .addCase(getMyDonationCollection.rejected, (state, action) => {
        state.loading = false;
        state.status = "idle";
      })
      .addCase(getCollection.pending, (state, action) => {
        state.status = "in-progress";
      })
      .addCase(getCollection.fulfilled, (state, action) => {
        state.collectionById = action.payload;
      })
      .addCase(getCollection.rejected, (state, action) => {
        state.status = "idle";
      })
      .addCase(getDonorDetailById.pending, (state, action) => {
        state.status = "in-progress";
      })
      .addCase(getDonorDetailById.fulfilled, (state, action) => {
        state.status = "idle";
        state.donorDetail = action.payload;
      })
      .addCase(getDonorDetailById.rejected, (state, action) => {
        state.status = "idle";
      })
      .addCase(GetEntityPreferenceEmail.pending, (state, action) => {
        state.status = "in-progress";
      })
      .addCase(GetEntityPreferenceEmail.fulfilled, (state, action) => {
        state.status = "idle";
        state.donorDetail = action.payload;
      })
      .addCase(GetEntityPreferenceEmail.rejected, (state, action) => {
        state.status = "idle";
      });
  },
});

export const { resetCollection, setCollectionId } = collectionSlice.actions;
export default collectionSlice.reducer;

export const getCollection = createAsyncThunk(
  "Collection/getCollectionById",
  async (data, { getState }) => {
    try {
      const {
        auth: {
          user: { token, userId },
        },
      } = getState();

      const res = await API.getCollection(
        `Collection/GetCollection`,
        data,

        token
      );
      return res.data.obj;
    } catch (error) {
      throw error;
    }
  }
);
